import { get, post } from "@/utils/request";
//账套编号申请
export const startAccountSetApplication = (params: any) => post("/api/accountSetApplication/startAccountSetApplication", params);
//获取账套编号详情
export const accountSetApplicationDetail = (params: any) => post("/api/accountSetApplication/detail", params);
